// extracted by mini-css-extract-plugin
export default {"page":"navigation_page__D+6Xj","separator":"navigation_separator__YnvMY","menu":"navigation_menu__Nxaa+","sticky-menu":"navigation_sticky-menu__mz3IM"};